var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_181",
    "data-name": "Ret\\xE2ngulo 181",
    width: 16,
    height: 16,
    transform: "translate(-0.244 -0.244)",
    fill: "#5b5b5b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line",
    transform: "translate(0.244 0.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M2.174,12.613v.01l.294.276L12.9,2.466l-.29-.3a.392.392,0,0,1,0-.552l.009-.005.741-.755.756-.737a.376.376,0,0,1,.552,0v.01l.746.746.75.741a.383.383,0,0,1,0,.552l0,.005-.746.746-.746.755a.4.4,0,0,1-.552,0l-.01-.009-.29-.29L3.38,13.82l.29.3a.392.392,0,0,1,0,.552H3.661l-.741.746-.746.755a.4.4,0,0,1-.562,0V16.16l-.746-.746-.751-.746a.391.391,0,0,1,0-.552l.005-.009.746-.737.746-.756a.4.4,0,0,1,.562,0m12.7-11.2h0L14.385.937l-.474.474-.48.489.48.474.474.475.484-.475.47-.474Zm-12.5,12.5h0l-.474-.475-.475.475-.479.479.479.475.475.475.474-.475.479-.475Z",
    transform: "translate(0 -0.016)",
    fill: "#5b5b5b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.c4cb9c3390032ad943a7456e7f65d1c2.svg";
export { ForwardRef as ReactComponent };